/**
 * sort ascending
 */
export const ASC = 'ASC';

/**
 * sort descending
 */
export const DESC = 'DESC';

/**
 * default table pagination configuration
 */
export const LIMIT_PER_PAGE_LIST = [5, 10, 20, 50, 100].map(size => ({
    key: size,
    value: size,
    text: size,
}));

/**
 * default parameters for clip configs
 */
export const DEFAULT_PARAMS_CLIP_CONFIG = {
    order: ASC,
    orderBy: 'name',
};

export const DEFAULT_PARAMS_SPIIDEO_VENUES = {
    order: ASC,
    orderBy: 'venue',
};

export const DEFAULT_PARAMS_SPIIDEO_COMPETITORS = {
    order: ASC,
    orderBy: 'sport',
};

const NO_SORT_STRATEGY = () => ({orderBy: null, order: null});

const omitUnchangedDefaultSortParams = (defaultParams) => ({state}) => {
    const anyDefaultParamsChanged = defaultParams.order !== state.direction
        || defaultParams.orderBy !== state.column;

    return {
        orderBy: anyDefaultParamsChanged ? state.column : null,
        order: anyDefaultParamsChanged ? state.direction : null,
    };
};

/**
 * table sorting strategies definition for selected sub-paths
 * paths are deliberately provided as strings instead of routes.js .path properties to omit importing whole route object
 */
export const TABLE_SORT_PARAMS_STRATEGIES = {
    '/clip-configuration': omitUnchangedDefaultSortParams(DEFAULT_PARAMS_CLIP_CONFIG),

    '/clip-configuration/add-on-sport-level': NO_SORT_STRATEGY,

    '/clip-configuration/add-on-tournament-level': NO_SORT_STRATEGY,

    // matched via props.match.path, not window.location.pathname
    '/clip-configuration/:id': NO_SORT_STRATEGY,

    '/spiideo-mappings/venues': omitUnchangedDefaultSortParams(DEFAULT_PARAMS_SPIIDEO_VENUES),

    '/spiideo-mappings/competitors': omitUnchangedDefaultSortParams(DEFAULT_PARAMS_SPIIDEO_COMPETITORS),

    default: ({state}) => ({
        orderBy: state.column,
        order: state.direction,
    }),
};
